module.exports = __webpack_public_path__ + "img/8-10.1e1e12f7.png";